module.exports = __webpack_public_path__ + "static/media/File.563b17b0.svg";